import getMuiTheme from "material-ui/styles/getMuiTheme";

export const ThemeProvider = getMuiTheme({
    appBar: {
        color: "rgb(0,51,183)"
    },
    tabs: {
        backgroundColor: "rgb(120,190,32)"
    },
    inkBar: {
        backgroundColor: "rgb(0,51,160)"
    },
    textField: {
        borderColor: "rgb(0,51,160)",
        focusColor: "rgb(0,51,160)",
        floatingLabelColor: "rgb(0,51,160)",
        errorColor: "rgb(244,67,54)",
        disabledTextColor: "rgb(0,0,0)"
    },
    datePicker: {
        headerColor: "rgb(0,51,160)",
        selectColor: "rgb(0,51,160)",
        color: "rgb(0,51,160)",
        calendarTextColor: "rgb(0,51,160)"
    },
    raisedButton: {
        color: "rgb(0,51,160)",
        textColor: "rgb(255,255,255)"
    }
});


// WEBPACK FOOTER //
// ./src/co/sura/inicio/componentes/ThemeProvider.ts